let store: any
if (process.env.NODE_ENV === 'production') {
    console.log('prod store.')
    store = require('./redux.prod')
} else {
    console.log('dev store.')
    store = require('./redux.dev')
}
export default store.default()